import { TableCell } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { Tabela } from '../../components/Tabela/index'
import msgConstants from '../../constants/msgConstants'
import { DetalhesRegularizacaoPendente } from '../../types/regularizacaoOPsTitulosTypes'
import { cabecalhoRegularizacaoPendente } from '../../types/tabelaTypes'
import { formateCurrency, formateDate, validarTexto } from '../../utils/stringUtils'
import { ContainerPesquisa } from './components/ContainerPesquisa'
import { RegularizacaoPedidosInformacoesIO } from './RegularizacaoPedidosInformacoes.IO'
import { Tipografia } from './../../components/Tipografia/index'

export type RegularizacaoPedidosInformacoesProps = {}

export function RegularizacaoPedidosInformacoesView({ _io }: IOProps<RegularizacaoPedidosInformacoesIO, RegularizacaoPedidosInformacoesProps>) {
  const { ContainerTable, TableRow } = _io.styles
  const possuiResultados = _io.pendenciaRegularizacao && _io.pendenciaRegularizacao.itens.length > 0

  function linhaTabela(props: { item: DetalhesRegularizacaoPendente }) {
    const { item } = props

    return (
      <TableRow hover onClick={(event) => _io.handleDirecionarRegularizacao(event, item.pedidoMkp)}>
        <TableCell>{item.ciclo.toLocaleString('pt-BR')}</TableCell>
        <TableCell>{validarTexto(item.parceiro, '-')}</TableCell>
        <TableCell>{item.pedidoMkp}</TableCell>
        <TableCell>{validarTexto(item.clienteId, '-')}</TableCell>
        <TableCell>{item.parcela}</TableCell>
        <TableCell>{formateCurrency(item.valorSaldo)}</TableCell>
        <TableCell>{formateDate(item.dataPagamento)}</TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <Tipografia variant="h5">Regularização de pedidos</Tipografia>
      <ContainerPesquisa
        listaParceirosAtivos={_io.parceirosAtivos}
        control={_io.control}
        limparFormularioPesquisa={_io.limparFormularioPesquisa}
        aplicarFiltro={_io.handleSubmit(_io.buscarValorPesquisado)}
        itemFormularioPreenchido={_io.formularioPreenchido}
      />
      {possuiResultados && (
        <ContainerTable>
          <Tipografia variant="h6">Resultados</Tipografia>
          <Tabela
            cabecalho={cabecalhoRegularizacaoPendente}
            itensLista={_io.pendenciaRegularizacao.itens}
            LinhaTabela={linhaTabela}
            orderCampoPadrao={'pedidoMkp'}
            rowsPerPageOptions={[25, 50, 100]}
            linhasPorPaginaPadrao={25}
            maxHeight={'none'}
            alinharTextoCentro={false}
            totalItens={_io.pendenciaRegularizacao.totalItens}
            buscarItensTabela={_io.aplicarFiltro}
          />
        </ContainerTable>
      )}
      {!possuiResultados && _io.pesquisaRealizada && (
        <ContainerTable>
          <Tipografia variant="body1">{msgConstants.REGULARIZACAO.semPendenciasPedido}</Tipografia>
        </ContainerTable>
      )}
    </>
  )
}
